import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var ImageIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 10.8078C2 9.03297 3.43392 7.58002 5.22667 7.58002H42.7733C44.5539 7.58002 46 9.03296 46 10.82V34.6247C46 34.9956 45.7767 35.33 45.4341 35.4719C45.0916 35.6138 44.6973 35.5354 44.4352 35.2731L35.2444 26.0793L28.1193 33.2069C27.9473 33.3789 27.7139 33.4756 27.4707 33.4754C27.2274 33.4753 26.9942 33.3785 26.8223 33.2063L14.6372 20.9938L3.56485 32.0698C3.30268 32.3321 2.90841 32.4105 2.56587 32.2686C2.22334 32.1267 2 31.7923 2 31.4214V10.8078ZM5.22667 9.41397C4.45275 9.41397 3.83333 10.0395 3.83333 10.8078V29.2076L13.9896 19.0479C14.1616 18.8759 14.3949 18.7792 14.6382 18.7794C14.8815 18.7795 15.1147 18.8763 15.2866 19.0486L27.4717 31.261L34.5963 24.1341C34.9542 23.776 35.5346 23.776 35.8926 24.1341L44.1667 32.4109V10.82C44.1667 10.0395 43.535 9.41397 42.7733 9.41397H5.22667Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9896 19.0724C14.3476 18.7143 14.928 18.7143 15.286 19.0724L27.4717 31.261L34.5963 24.1341C34.9542 23.776 35.5346 23.776 35.8926 24.1341L45.7315 33.9763C45.9034 34.1483 46 34.3815 46 34.6247V37.18C46 38.9702 44.5507 40.42 42.7611 40.42H5.22667C3.45246 40.42 2 38.9856 2 37.1923V31.4459C2 31.2027 2.09658 30.9694 2.26849 30.7975L13.9896 19.0724ZM3.83333 31.8257V37.1923C3.83333 37.9664 4.45865 38.5861 5.22667 38.5861H42.7611C43.5382 38.5861 44.1667 37.9574 44.1667 37.18V35.0045L35.2444 26.0793L28.1193 33.2069C27.7613 33.565 27.1803 33.5644 26.8223 33.2063L14.6378 21.0176L3.83333 31.8257Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7889 15.3804C26.3984 15.3804 25.2711 16.5081 25.2711 17.8991C25.2711 19.2901 26.3984 20.4177 27.7889 20.4177C29.1794 20.4177 30.3067 19.2901 30.3067 17.8991C30.3067 16.5081 29.1794 15.3804 27.7889 15.3804ZM23.4378 17.8991C23.4378 15.4952 25.3858 13.5465 27.7889 13.5465C30.1919 13.5465 32.14 15.4952 32.14 17.8991C32.14 20.3029 30.1919 22.2516 27.7889 22.2516C25.3858 22.2516 23.4378 20.3029 23.4378 17.8991Z"
  }));
});
ImageIcon.displayName = 'ImageIcon';
ImageIcon.defaultProps = {
  'aria-label': 'Image'
};
export default ImageIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/ImageIcon/index.js
// module id = 1868
// module chunks = 12